import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";

@Component({
    selector: "wbo-text-column",
    templateUrl: "./text-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => TextColumnComponent), multi: true}
    ]
})
export class TextColumnComponent extends AbstractColumnComponent {
    @Input() showPlaceholderForCell: boolean;

    constructor(injector: Injector) {
        super(injector);
    }
}
